"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProperty;
function getProperty(object, keyPath, defaultValue) {
  var value = keyPath.reduce(function (previousValue, key) {
    return previousValue != null ? previousValue[key] : undefined;
  }, object);
  return value != null ? value : defaultValue;
}